'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reduxLogger = require('redux-logger');

var _reactRouterRedux = require('react-router-redux');

var _createSocketMiddleware = require('../utils/socket/middleware/createSocketMiddleware');

var _undoRedoMiddleware = require('../utils/undoRedo/middleware/undoRedoMiddleware');

var _undoRedoMiddleware2 = _interopRequireDefault(_undoRedoMiddleware);

var _analyticsMiddleware = require('../analytics/analyticsMiddleware');

var _analyticsMiddleware2 = _interopRequireDefault(_analyticsMiddleware);

var _filterStateRoutingMiddleware = require('./filterStateRoutingMiddleware');

var _filterStateRoutingMiddleware2 = _interopRequireDefault(_filterStateRoutingMiddleware);

var _createElementConnectionsMiddleware = require('../components/connections/createElementConnectionsMiddleware');

var _createElementConnectionsMiddleware2 = _interopRequireDefault(_createElementConnectionsMiddleware);

var _elementCountMiddleware = require('../user/elementCount/elementCountMiddleware');

var _elementCountMiddleware2 = _interopRequireDefault(_elementCountMiddleware);

var _addStateToWindowMiddleware = require('./addStateToWindowMiddleware');

var _addStateToWindowMiddleware2 = _interopRequireDefault(_addStateToWindowMiddleware);

var _forceElementLoadMiddleware = require('./forceElementLoadMiddleware');

var _forceElementLoadMiddleware2 = _interopRequireDefault(_forceElementLoadMiddleware);

var _reduxBulkingMiddleware = require('./reduxBulkingMiddleware');

var _getClientConfig = require('../utils/getClientConfig');

var _getClientConfig2 = _interopRequireDefault(_getClientConfig);

var _debugUtil = require('../debug/debugUtil');

var _configConstants = require('../../../config/configConstants');

var _loggingConfig = require('./loggingConfig');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
    var browserHistory = _ref.browserHistory,
        elementConnectionsManager = _ref.elementConnectionsManager,
        socketManager = _ref.socketManager;

    var middlewareList = [];
    var config = (0, _getClientConfig2.default)();

    middlewareList.push(_reduxThunk2.default);
    middlewareList.push(_undoRedoMiddleware2.default);

    if (browserHistory) middlewareList.push((0, _reactRouterRedux.routerMiddleware)(browserHistory));
    if (elementConnectionsManager) middlewareList.push((0, _createElementConnectionsMiddleware2.default)(elementConnectionsManager));

    middlewareList.push(_elementCountMiddleware2.default);
    middlewareList.push(_filterStateRoutingMiddleware2.default);

    middlewareList.push((0, _analyticsMiddleware2.default)());

    if (socketManager) middlewareList.push((0, _createSocketMiddleware.createSocketMiddleware)(socketManager));

    middlewareList.push((0, _reduxBulkingMiddleware.bulkingMiddleware)());
    middlewareList.push(_forceElementLoadMiddleware2.default);

    if (config.debugLevel > _configConstants.DEBUG_LEVEL.OFF) {
        var filteredActions = _loggingConfig.LOG_FILTER_ACTIONS.filter(function (logLevel) {
            return logLevel >= config.debugLevel;
        }).keySeq().toArray();

        middlewareList.push((0, _reduxLogger.createLogger)({
            predicate: function predicate(getState, action) {
                return filteredActions.indexOf(action.type) === -1;
            },
            collapsed: true,
            duration: true,
            titleFormatter: function titleFormatter(action, time, took) {
                if (action.type === _reduxBulkingMiddleware.BATCH_ACTION_TYPE) {
                    var actions = action.payload.map(function (a) {
                        return a.type;
                    }).join(', ');
                    return 'batch action: ' + actions + ' (in ' + took.toFixed(2) + ' ms)';
                }

                return 'action ' + action.type + ' (in ' + took.toFixed(2) + ' ms)';
            }
        }));

        if (_debugUtil.isDebugEnabled) {
            middlewareList.push(_addStateToWindowMiddleware2.default);
        }
    }

    if (_debugUtil.isDebugEnabled) {
        middlewareList.push(_addStateToWindowMiddleware2.default);
    }

    return middlewareList;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/store/getMiddleware.js
// module id = 2052
// module chunks = 0